import { provideHttpClient } from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withNavigationErrorHandler } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import { psychologyLivingPreset } from '../theme/psychology-living-preset';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(),
    provideRouter(
      routes,
      // Dopo un deploy, una tab aperta con la build vecchia chiede chunk lazy con hash
      // ormai rimossi dal server → 404. Un reload carica la build nuova.
      withNavigationErrorHandler((e) => {
        if (/dynamically imported module|chunk/i.test(String(e.error))) {
          // ponytail: guard anti-loop, massimo un reload per URL
          if (sessionStorage.getItem('chunk-reload') !== location.href) {
            sessionStorage.setItem('chunk-reload', location.href);
            location.reload();
          }
        }
      }),
    ),
    providePrimeNG({
      theme: {
        preset: psychologyLivingPreset,
        options: {
          darkModeSelector: false,
        },
      },
      license:
        'eyJpZCI6ImY5MTM2Y2ZjLTVlMTYtNGM2Ni1hMDk2LWI4YTQ2NTAzOGY3MSIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODQ2MjcxMzAsImV4cCI6MTgxNjE2MzEzMH0.fs7Q0LQE6MJPeDL3-fOh_KOQlIa8_30PA8ZCGcjF9g2Pd0o1U3Xyk2A0R-hgxNUwSk7klb5eUw1wE8kBC6xoBQ',
    }),
    MessageService,
    ConfirmationService,
    DialogService,
  ],
};
